import { ComponentType, useState } from 'react';

import {
  DevHubButton,
  DevHubBox,
  DevHubDynamicIcon,
  DevHubColorProps,
} from '@devxdiscover/devhub-ui';
import { PluginModal } from './PluginModal';

/**
 * Plugin button for plugin support.
 * @param props Props passed to the button component
 * @constructor
 */
export const PluginButton = (props: {
  buttonColor: DevHubColorProps;
  modalContent: ComponentType<any>;
}) => {
  const [openModal, setOpenModal] = useState(false);
  const { buttonColor, modalContent: ModalContent } = props;

  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <>
      <DevHubBox display="flex" justifyContent="flex-end">
        <DevHubButton
          aria-label="Plugin Support"
          textColor={buttonColor ?? 'primary'}
          onClick={handleOpen}
          startIcon={<DevHubDynamicIcon iconName="Help" />}
        >
          Plugin Support
        </DevHubButton>
      </DevHubBox>
      <PluginModal
        handleClose={handleClose}
        open={openModal}
        modalContent={ModalContent}
      />
    </>
  );
};
